import React from 'react';
import Slider from 'react-slick';
import { BusReviews } from '../../pages/runtime-typechecker';
import './OperatorReviews.css';
import '../../styles/slick.css';
import '../../styles/slick-theme.css';

type OperatorReviewsProps = {
  busReviews: BusReviews[];
  isMobileDevice: boolean;
};

const OperatorReviews = ({
  busReviews,
  isMobileDevice
}: OperatorReviewsProps) => {
  const SampleNextArrow = props => {
    const { className, onClick } = props;
    return (
      <div className={className} style={{ display: 'flex' }} onClick={onClick}>
        {!isMobileDevice && <button></button>}
      </div>
    );
  };

  const SamplePrevArrow = props => {
    const { className, onClick } = props;
    return (
      <div className={className} style={{ display: 'flex' }} onClick={onClick}>
        {!isMobileDevice && <button></button>}
      </div>
    );
  };

  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    className: 'reviewSlickCarousel',
    slidesToShow: 4.2,
    swipeToSlide: true,
    slidesToScroll: 1,
    adaptiveHeight: false,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          dots: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 2.2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 620,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1.4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 400,
        settings: {
          slidesToShow: 1.3,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <div className="operatorReviews makeRelative">
      <Slider {...settings}>
        {busReviews.map(
          ({
            overallRating,
            subjectiveReview,
            dateOfJourney,
            sourceCity,
            destCity
          }) => (
            <div className="reviewsCard blackText">
              <p className="makeFlex hrtlCenter appendBottom8">
                {overallRating >= 4 ? (
                  <span className="reviewTag greenBg font16 appendRight8">
                    {overallRating}
                  </span>
                ) : (
                  <span className="reviewTag orangeBg font16 appendRight8">
                    {overallRating}
                  </span>
                )}
                <span className="font12 lightGreyText">{dateOfJourney}</span>
              </p>
              <p className="font12 appendBottom10">
                {`${sourceCity} to ${destCity}`}
              </p>
              <p className="font14 lineHeight18">{subjectiveReview}</p>
            </div>
          )
        )}
      </Slider>
    </div>
  );
};

export default OperatorReviews;
